<template>
  <div id="footer">
    <div class="footer_box">
      <div class="footer_links footer_links1">
        <!-- <router-link :to="{ path: '/about', query: { nav: 6 } }" tag="a"
          >关于我们<em></em
        ></router-link> -->
        <router-link :to="{ path: '/course_list', query: { nav: 8 } }" tag="a">精品课程<em></em></router-link>
        <!-- <router-link :to="{ path: '/publicclass_list', query: { nav: 3 } }" tag="a">热门公开课<em></em></router-link> -->
        <router-link :to="{ path: '/languageTest', query: { nav: 5 } }" tag="a">入学测试<em></em></router-link>
        <router-link :to="{ path: '/teacher_list', query: { nav: 1 } }" tag="a">启德教师<em></em></router-link>
        <router-link :to="{ path: '/selfStudy_list', query: { nav: 2 } }" tag="a">自学备考专区<em></em></router-link>
        <!-- <router-link :to="{ path: '/testPrep', query: { nav: 4 } }" tag="a"
          >免费备考工具<em></em
        ></router-link> -->
        <router-link :to="{ path: '/downloads', query: { nav: 7 } }" tag="a">客户端下载<em></em></router-link>
        <!-- <router-link :to="{ path: '/shop_list' }" tag="a">积分商城</router-link> -->
      </div>
      <div class="footer_links footer_links2">
        友情链接：<a href="https://www.eic.org.cn/" target="_blank">启德教育官网</a><a href="https://www.eickaopei.com/"
          target="_blank">启德考培官网</a>
      </div>
      <div class="connection">
        <img src="../assets/index/phone.png">400-002-2508<span>(咨询时间：9:00-21:00)</span>
      </div>
      <div class="footer_dw">
        <span><img src="https://kpimg.eiceducation.com.cn/school_img/09e016110a4e43ce96291591f102d7f4" />Android下载</span>
        <span><img src="https://lximg.eiceducation.com.cn/img/092bdce2c09e4adc84b2c64ea46b72b1" />IOS下载</span>
      </div>
    </div>
    <div class="footer_icp">
      <div class="footer_logo">
        <img src="../assets/index/logo.png" alt="" />
      </div>
      Copyright@2003-2021启德考培在线 www.eickaopei.com All Rights Reserved<br />
      <a href="https://beian.miit.gov.cn" target="_blank">
        <img style="vertical-align: middle;" src="../assets/index/beian.png" alt="">
        鲁ICP备2022002161号-3
      </a>
      <a href="https://beian.miit.gov.cn" target="_blank">
        <img style="vertical-align: middle;" src="../assets/index/beian.png" alt="">
        鲁公网安备37010202002902号
      </a>
      <br />
      已授权广东启德教育服务有限公司使用
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {

      }
    },


    methods: {

    }
  }
</script>

<style scoped lang="less">
  #footer {
    width: 100%;
    height: 281px;
    background: #FFF;
    min-width: 1200px;
    border-top: 1px #FF0659 solid;
  }

  .footer_box {
    width: 1200px;
    margin: 0 auto;
    padding-top: 56px;
    position: relative;
  }

  .footer_links1 {
    width: 100%;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 20px;
  }

  .footer_links1 a {
    font-size: 16px;
    color: #333333;
    margin-right: 30px;
  }

  .footer_links2 {
    width: 100%;
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 20px;
    color: #333333;
    margin-bottom: 30px;
  }

  .footer_links2 a {
    font-size: 12px;
    color: #333333;
    margin-right: 20px;
  }

  .connection {
    width: 100%;
    height: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    padding-bottom: 20px;
  }

  .connection img {
    display: block;
    float: left;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .connection span {
    line-height: 20px;
    font-size: 12px;
    padding-left: 10px;
  }

  .footer_dw {
    position: absolute;
    top: 52px;
    right: 0;
  }

  .footer_dw span {
    display: block;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 12px;
    float: right;
    margin-left: 52px;
    text-align: center;
  }

  .footer_dw span img {
    display: block;
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }

  .footer_logo {
    width: 1180px;
    height: 53px;
    margin: 0 auto;
    margin-bottom: 12px;
    position: relative;
  }

  .footer_logo img {
    float: left;
  }

  .footer_logo .footer_dw {
    width: 500px;
    position: absolute;
    top: -42px;
    right: 0;
  }

  .footer_logo .footer_dw span {
    width: 86px;
    display: block;
    margin-left: 46px;
    float: right;
    font-size: 12px;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  .footer_logo .footer_dw span img {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border-radius: 4px;
    padding: 3px;
  }

  .footer_icp {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    font-size: 12px;
    line-height: 16px;
    border-top: 1px #999999 solid;
    padding-top: 20px;
    color: #333333;
  }

  .footer_icp a {
    color: #333333;
  }

  .footer_logo {
    float: left;
    width: 142px;
  }

  .footer_logo img {
    display: block;
    width: 142px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue